import { FC } from 'react';
import { TTheme } from 'widgets/choose-background/ui/types';
import { ImagesTab } from './ImagesTab';
import VideosTab from './VideosTab';

interface IProps {
  theme: TTheme;
  onChange: (value: string) => void;
  customImageBackgrounds: string[];
  setCustomImageBackgrounds: (backgrounds: string[]) => void;
  setCustomVideoBackgrounds: (value: string[]) => void;
  customVideoBackgrounds: string[];
  selectedBackground: string;
}

export const MediaTab: FC<IProps> = ({
  theme,
  selectedBackground,
  customImageBackgrounds,
  setCustomImageBackgrounds,
  onChange,
  customVideoBackgrounds,
  setCustomVideoBackgrounds
}) => {
  return (
    <div className="ag-flex ag-flex-col ag-gap-y-4">
      <ImagesTab
        theme={theme}
        onChange={onChange}
        customImageBackgrounds={customImageBackgrounds}
        setCustomImageBackgrounds={setCustomImageBackgrounds}
        selectedBackground={selectedBackground}
      />
      <VideosTab
        theme={theme}
        onChange={onChange}
        setCustomVideoBackgrounds={setCustomVideoBackgrounds}
        customVideoBackgrounds={customVideoBackgrounds}
        selectedBackground={selectedBackground}
      />
    </div>
  );
};
